<template>
    <div>
          <div
            v-for="(cellsOnPage, pageIdx) in sheetPages"
            :key="'page-' + pageIdx"
            :style="sheetStyle(ppm, forPrint)"
            class="sheet-page"
          >
            <div
              v-for="n in cellsOnPage"
              :key="'cell-' + pageIdx + '-' + n"
              :style="sheetCellStyle(ppm, forPrint)"
            >
              <div
                v-for="(field, index) in fn_cellFields(pageIdx, n)"
                :key="'sheet-' + pageIdx + '-' + n + '-' + index"
                :style="sheetFieldStyle(field, ppm)"
              >
                <div v-if="field.fieldName === 'Image' && field.imageData" class="field-content">
                  <img :src="field.imageData" style="width:100%;height:100%;object-fit:contain;">
                </div>
                <!-- The barcode carries its own value, so the draw pass never has
                     to map an index back to a field. That matters here because
                     each cell can hold a different product. -->
                <div v-else-if="field.fieldName === 'Barcode'" class="field-content">
                  <svg
                    :data-barcode-value="field.fieldValue || '123456789'"
                    style="height:100%;width:auto;max-width:100%;display:block;"
                  ></svg>
                </div>
                <div v-else class="field-content">
                  <span>{{ printText(field) }}</span>
                </div>
              </div>
            </div>
          </div>
    </div>
</template>

<script>
export default {
  props: {
    sheetPages: { type: Array, default: () => [] },
    // Style factories from the parent; each accepts a px-per-mm value.
    sheetStyle: { type: Function, required: true },
    sheetCellStyle: { type: Function, required: true },
    sheetFieldStyle: { type: Function, required: true },
    // The label design, repeated in every cell (designer use).
    fields: { type: Array, default: () => [] },
    // Optional per-cell field arrays, flat across all pages (generator use):
    // cells[0] is the first label on page 1, and so on. Falls back to `fields`.
    cells: { type: Array, default: null },
    printText: { type: Function, required: true },
    // px-per-mm for this surface; null lets the parent fall back to preview scale.
    ppm: { type: Number, default: null },
    // Print surface: true mm, no cell guides.
    forPrint: { type: Boolean, default: false }
  },

  methods: {
    // n is Vue's 1-based v-for counter within the page; translate it to a flat
    // index across pages so per-cell data lines up with what's rendered.
    fn_cellFields(pageIdx, n) {
      if (!this.cells) return this.fields;
      let offset = 0;
      for (let p = 0; p < pageIdx; p++) offset += this.sheetPages[p];
      return this.cells[offset + n - 1] || this.fields;
    }
  }
}
</script>

<style scoped>
/* Mirror the label preview's .field-content so a barcode's height:100% has a
   definite parent height to resolve against. Without this, the barcode falls
   back to its intrinsic size and max-width:100% stretches it to the full cell
   width — making sheet barcodes wider than the designed field height. */
.field-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/barcode/components/print_sheet.vue